"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromOrderItemToValues = exports.orderItemBuilderFactory = void 0;
const assert_never_1 = __importDefault(require("assert-never"));
const immer_1 = require("immer");
const spu_1 = require("@tencent/tccp-frontend-contract/spu");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const orderItemBuilderFactory = (spuCode) => (clientParamList, current) => {
    const rootOrderSpuItemDraft = (0, immer_1.createDraft)({
        SpuValue: {
            SpuCode: spuCode,
            SpecList: [],
        },
        Quantity: 0,
    });
    const externalParameterList = [];
    const spuItemStack = [];
    let currentSpuItem = rootOrderSpuItemDraft;
    for (const param of clientParamList) {
        // 不匹配了？先退栈
        while (spuItemStack.length > param.depth) {
            currentSpuItem = spuItemStack.pop();
        }
        // 是引用SPU？
        if (param.isRef) {
            const currentSpuCode = param.spec.ValueRestrictionList.at(0).RestrictionRuleList.at(0).SpuCode;
            const item = {
                SpecCode: param.spec.SpecCode,
                // 有ReferencedSpecValueList的情况下，不赋值SpecValue
                // SpecValue: currentSpuCode,
                ReferencedSpecValueList: [
                    {
                        SpuValue: {
                            SpuCode: currentSpuCode,
                            SpecList: [],
                        },
                        Quantity: 0,
                    },
                ],
            };
            currentSpuItem.SpuValue.SpecList.push(item);
            // 去下一层
            spuItemStack.push(currentSpuItem);
            currentSpuItem = currentSpuItem.SpuValue.SpecList.at(-1).ReferencedSpecValueList.at(0);
            continue;
        }
        const currentValue = current[param.paramKey];
        // 没有的参数直接跳过
        if (currentValue === undefined || currentValue === null || Number.isNaN(currentValue)) {
            continue;
        }
        // 不是引用SPU，直接往这一层级加
        // if (param.paramType === ParamTypeEnum.Measure) {
        //   currentSpuItem.MeasureValue = currentValue as number;
        // }
        if (param.paramType === trade_1.ParamTypeEnum.Quantity) {
            currentSpuItem.Quantity = currentValue;
        }
        else if (param.paramType === trade_1.ParamTypeEnum.ExternalParameter) {
            // 额外参数单独处理
            const valueStr = typeof currentValue === 'string' ? currentValue : JSON.stringify(currentValue);
            externalParameterList.push({
                ParamCode: param.spec.SpecCode,
                ParamValue: valueStr,
                // 额外参数没有引用部件
            });
        }
        else {
            // 普通规格
            // 转字符串
            const valueStr = typeof currentValue === 'string' ? currentValue : JSON.stringify(currentValue);
            const item = {
                SpecCode: param.spec.SpecCode,
                SpecValue: valueStr,
            };
            currentSpuItem.SpuValue.SpecList.push(item);
        }
    }
    const rootOrderSpuItem = (0, immer_1.finishDraft)(rootOrderSpuItemDraft);
    return {
        SpuItem: rootOrderSpuItem,
        ExternalParameterList: externalParameterList,
    };
};
exports.orderItemBuilderFactory = orderItemBuilderFactory;
function fromOrderItemToValues(orderItem, paramList) {
    const { SpuItem, ExternalParameterList = [] } = orderItem;
    const result = {};
    if (!SpuItem) {
        return result;
    }
    function visit(spuItem, prevPathList = [], externalParameterList = []) {
        var _a;
        const { SpuValue: { SpuCode, SpecList }, Quantity, } = spuItem;
        // 先配置数量和用量
        if (Quantity !== undefined && Quantity !== null) {
            const path = `${trade_1.ParamTypeEnum.Quantity}://${[...prevPathList, SpuCode].join('>')}`;
            result[path] = Quantity;
        }
        // if (MeasureValue !== undefined && MeasureValue !== null) {
        //   const path = `${ParamTypeEnum.Measure}://${[...prevPathList, SpuCode].join('>')}`;
        //   result[path] = MeasureValue;
        // }
        for (const spec of SpecList) {
            const visited = [...prevPathList, `${SpuCode}.${spec.SpecCode}`];
            if ((_a = spec.ReferencedSpecValueList) === null || _a === void 0 ? void 0 : _a.length) {
                // 引用规格
                for (const refSpu of spec.ReferencedSpecValueList) {
                    visit(refSpu, visited);
                }
            }
            else if (spec.SpecValue !== undefined && spec.SpecValue !== null) {
                // 一般规格
                const path = `${trade_1.ParamTypeEnum.Spec}://${visited.join('>')}`;
                result[path] = spec.SpecValue;
            }
        }
        for (const externalParameter of externalParameterList) {
            const visited = [...prevPathList, `${SpuCode}.${externalParameter.ParamCode}`];
            if (externalParameter.ParamValue !== undefined && externalParameter.ParamValue !== null) {
                // 扩展规格
                const path = `${trade_1.ParamTypeEnum.ExternalParameter}://${visited.join('>')}`;
                result[path] = externalParameter.ParamValue;
            }
        }
    }
    visit(SpuItem, [], ExternalParameterList);
    // 重设参数类型
    for (const param of paramList) {
        const key = param.paramKey;
        const value = result[key];
        if (value === undefined || value === null) {
            continue;
        }
        switch (param.paramType) {
            case trade_1.ParamTypeEnum.Quantity: {
                result[key] = Number(value);
                break;
            }
            case trade_1.ParamTypeEnum.Spec:
            case trade_1.ParamTypeEnum.ExternalParameter: {
                switch (param.spec.SpecValueType) {
                    case spu_1.ValueTypeEnum.Int:
                    case spu_1.ValueTypeEnum.Decimal: {
                        result[key] = Number(value);
                        break;
                    }
                    case spu_1.ValueTypeEnum.IntArray:
                    case spu_1.ValueTypeEnum.DecimalArray:
                    case spu_1.ValueTypeEnum.StringArray:
                    case spu_1.ValueTypeEnum.RefArray: {
                        try {
                            const realValue = JSON.parse(value);
                            result[key] = realValue;
                        }
                        catch (_a) { }
                        break;
                    }
                }
                break;
            }
            default: {
                (0, assert_never_1.default)(param.paramType);
            }
        }
    }
    return result;
}
exports.fromOrderItemToValues = fromOrderItemToValues;
